/* tslint:disable */
/* eslint-disable */
/**
 * Vayu API
 * The Vayu API is a RESTful API that allows you to submit events for processing and storage & manage billing related entities.           The API is secured using the Bearer Authentication scheme with JWT tokens.           To obtain a JWT token, please contact Vayu at team@withvayu.com
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@withvayu.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateContractStatusRequest
 */
export interface UpdateContractStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateContractStatusRequest
     */
    status: UpdateContractStatusRequestStatusEnum;
}


/**
 * @export
 */
export const UpdateContractStatusRequestStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type UpdateContractStatusRequestStatusEnum = typeof UpdateContractStatusRequestStatusEnum[keyof typeof UpdateContractStatusRequestStatusEnum];


/**
 * Check if a given object implements the UpdateContractStatusRequest interface.
 */
export function instanceOfUpdateContractStatusRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function UpdateContractStatusRequestFromJSON(json: any): UpdateContractStatusRequest {
    return UpdateContractStatusRequestFromJSONTyped(json, false);
}

export function UpdateContractStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContractStatusRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function UpdateContractStatusRequestToJSON(value?: UpdateContractStatusRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}

